import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPaperPlane = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 15,
	height: 13,
	viewBox: "0 0 15 13",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M7.92339 12.8761C8.00988 12.831 8.08355 12.7643 8.15885 12.7029C10.1454 8.72757 12.1382 4.73633 14.0303 0.718943C14.0719 0.369894 13.8099 0.0416836 13.4643 -0.000499088C9.15319 0.737113 4.85529 1.61219 0.548966 2.40103C-0.0168463 2.52573 -0.192991 3.16356 0.242312 3.54995L4.60546 6.50573L8.49645 3.5683C9.1318 3.28629 9.70348 4.03564 9.26147 4.57419L5.44093 7.48105L5.38838 7.55995L7.07524 12.5335C7.20748 12.8429 7.61856 13.0348 7.92339 12.8761Z",
		fill: "currentColor"
	})
});
export default SvgPaperPlane;
